export const STOCKTAKING_ORDERS_STATUSES = {
  pending: 'Oczekuje',
  assigned: 'Przypisane',
  finished: 'Zakończone',
  cancelled: 'Anulowane',
  undefined: '---'
}
